interface SliderProps {
  label: string;
  value: number;
  min: number;
  max: number;
  step?: number;
  onChange: (value: number) => void;
  formatValue?: (value: number) => string;
  tooltip?: string;
  disabled?: boolean;
}

export function Slider({ label, value, min, max, step = 1, onChange, formatValue, tooltip, disabled }: SliderProps) {
  return (
    <label className="block">
      <span className="mb-1 flex items-center justify-between text-xs font-medium text-slate-600 dark:text-slate-300">
        <span className="flex items-center gap-1">
          {label}
          {tooltip && (
            <span title={tooltip} className="cursor-help text-slate-400" aria-label={tooltip}>
              ⓘ
            </span>
          )}
        </span>
        <span className="tabular-nums text-slate-500 dark:text-slate-400">{formatValue ? formatValue(value) : value}</span>
      </span>
      <input
        type="range"
        min={min}
        max={max}
        step={step}
        value={value}
        disabled={disabled}
        onChange={(e) => onChange(Number(e.target.value))}
        className="w-full accent-brand-600 disabled:opacity-50"
        aria-label={label}
      />
    </label>
  );
}
